var render = function (_h,_vm) {var _c=_vm._c;return _c('section',_vm._b({class:['Sect', _vm.data.class, _vm.data.staticClass]},'section',_vm.data.attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }